// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-thread-card {
  --chat-surface-bg: var(--ct-card-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  background-color: var(--chat-surface-bg);
  box-shadow: var(--bs-box-shadow-sm);
  overflow: hidden;
}

.chat-thread-sidebar,
.chat-thread-header,
.chat-compose {
  background-color: var(--chat-surface-bg);
}

.chat-sidebar-column,
.chat-conversation-column,
.chat-info-column {
  min-height: 70vh;
}

#showUsersSwitch {
  --show-users-switch-off-knob: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%239aa0a6'/%3e%3c/svg%3e");
}
#showUsersSwitch:not(:checked) {
  --bs-form-switch-bg: var(--show-users-switch-off-knob);
  background-image: var(--show-users-switch-off-knob);
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
}
#showUsersSwitch:not(:checked):focus {
  --bs-form-switch-bg: var(--show-users-switch-off-knob);
  background-image: var(--show-users-switch-off-knob);
  background-color: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
  box-shadow: 0 0 0 0.15rem rgba(var(--bs-secondary-rgb), 0.18);
}

.chat-new-message-btn {
  font-weight: 600;
  border-radius: 0.375rem;
}

.chat-search .chat-search-icon {
  position: absolute;
  top: 50%;
  left: 0.8rem;
  transform: translateY(-50%);
  color: var(--bs-secondary-color);
}
.chat-search .chat-search-input {
  border-radius: 0.375rem;
  padding-left: 2.2rem;
  border-color: var(--bs-border-color);
  background-color: var(--chat-surface-bg);
}

.chat-thread-list {
  background-color: var(--chat-surface-bg);
}
.chat-thread-list .chat-thread-item {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  background-color: var(--chat-surface-bg);
  text-decoration: none;
  color: inherit;
  box-shadow: none;
}
.chat-thread-list .chat-thread-item:hover {
  background-color: rgba(var(--bs-secondary-rgb), 0.12);
  border-color: var(--bs-border-color);
}
.chat-thread-list .chat-thread-avatar {
  width: 40px;
  height: 40px;
}
.chat-thread-list .thread-meta {
  min-width: 66px;
}
.chat-thread-list .thread-meta small {
  font-size: 0.72rem;
  letter-spacing: 0.01em;
}

.active-thread {
  border-color: var(--bs-primary) !important;
  background-color: rgba(var(--bs-primary-rgb), 0.12) !important;
  box-shadow: inset 0 0 0 1px rgba(var(--bs-primary-rgb), 0.15);
}

.new-message-panel {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  padding: 0.75rem;
  background-color: var(--chat-surface-bg);
}

.new-conversation-picker {
  background-color: var(--chat-surface-bg);
}

.recipient-picker-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.recipient-search-input {
  padding-left: 2rem;
}

.recipient-picker-item {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  color: var(--bs-body-color);
  background-color: transparent;
}
.recipient-picker-item:hover {
  background-color: rgba(var(--bs-secondary-rgb), 0.18);
}
.recipient-picker-item.active {
  border-color: rgba(var(--bs-primary-rgb), 0.5);
  background-color: rgba(var(--bs-primary-rgb), 0.18);
  color: var(--bs-body-color);
}

.chat-conversation {
  background-color: var(--chat-surface-bg);
}
.chat-conversation .conversation-list {
  margin-bottom: 0;
  padding-top: 1.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.chat-conversation .conversation-list li {
  margin-bottom: 1rem;
}
.chat-conversation .ctext-wrap {
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  box-shadow: none;
  background: var(--chat-surface-bg);
  padding: 0.75rem 0.85rem;
}
.chat-conversation .ctext-wrap p {
  margin-bottom: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.chat-conversation .odd .ctext-wrap {
  background: var(--chat-surface-bg);
  border-color: var(--bs-border-color-translucent);
}

.chat-empty-state {
  min-height: 180px;
}

.chat-thread-header h5 {
  max-width: 85%;
}

.header-avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.chat-header-actions .btn {
  border-radius: 0.5rem;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.chat-compose {
  background-color: var(--chat-surface-bg);
}
.chat-compose .chat-input {
  min-height: 44px;
  max-height: 220px;
  border-radius: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  background-color: var(--chat-surface-bg);
  border-color: var(--bs-border-color);
  resize: none;
  overflow-y: auto;
  line-height: 1.4;
}
.chat-compose .chat-input:focus {
  border-color: rgba(var(--bs-primary-rgb), 0.45);
  box-shadow: 0 0 0 0.15rem rgba(var(--bs-primary-rgb), 0.12);
}

.chat-compose-actions {
  position: relative;
}

.chat-emoji-btn,
.chat-attach-btn {
  border-radius: 0.5rem;
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.chat-emoji-picker {
  position: absolute;
  right: 0;
  bottom: calc(100% + 0.5rem);
  z-index: 20;
  min-width: 210px;
  background-color: var(--chat-surface-bg);
  border-color: var(--bs-border-color);
}
.chat-emoji-picker .card-body {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.25rem;
}

.chat-emoji-item {
  border: 1px solid var(--bs-border-color-translucent);
  background: transparent;
  border-radius: 0.375rem;
  line-height: 1.2;
}
.chat-emoji-item:hover {
  background-color: rgba(var(--bs-secondary-rgb), 0.2);
}

.chat-send {
  min-width: 84px;
  font-weight: 600;
  border-radius: 0.5rem;
  min-height: 44px;
}

.chat-info-panel {
  background-color: var(--chat-surface-bg);
}

.chat-info-avatar {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border: 2px solid var(--bs-border-color);
}

.chat-info-row {
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.chat-info-row:last-child {
  border-bottom: 0;
}

.chat-info-last-seen {
  line-height: 1.35;
}

.chat-info-empty {
  min-height: 240px;
}

@media (max-width: 1399.98px) {
  .chat-conversation-column {
    border-right: 0 !important;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
